export const teachers = [
  {
    name: 'Ms. Adaeze Nwoke',
    role: 'Early years lead · 9 years here',
    quote:
      '“I have taught the younger brothers and sisters of my first class. That is the job.”',
  },
  {
    name: 'Mr. Bello Yusuf',
    role: 'Primary maths · 12 years here',
    quote:
      '“No child leaves my room believing they are bad at numbers. It is not allowed.”',
  },
  {
    name: 'Ms. Grace Etim',
    role: 'Reading specialist · 6 years here',
    quote:
      '“Twenty minutes a day, one child at a time. That is how reading actually happens.”',
  },
  {
    name: 'Mr. Chidi Okonkwo',
    role: 'Science & mentoring · 8 years here',
    quote:
      '“I meet my mentees in Grade 6 and shake their hand at graduation. Same hand.”',
  },
];
